module.exports = __webpack_public_path__ + "img/query.a09fa674.png";